import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Gallery from '@/components/Gallery'
import { Input, Button, Form, message } from 'mk-pc'
import { getImageCaptcha } from '../service'
import { useAuth } from '@/hooks'
import '../styles/login.scss'
/* 轮播图图片 */
import slogan1 from '../images/slogan1.png'
import slogan2 from '../images/slogan2.png'

/**
 * 登录
 * @returns
 */
export const Login = () => {
  const { userLogin } = useAuth()
  const { search } = useLocation()
  const [form] = Form.useForm()
  const [imageData, setImageData] = useState({} as { key: string; code: string; image: string })
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    fetchImageCaptcha()
  }, [])

  /**
   * 获取图形验证码
   */
  const fetchImageCaptcha = () => {
    getImageCaptcha().then((res: { key: string; code: string; image: string }) => {
      setImageData(res)
    })
  }

  /**
   * 获取回跳地址
   * @returns
   */
  const getRedirect = () => {
    const params = search.replace(/\?/g, '').split('&')
    let url = ''
    for (const param of params) {
      const [key, value] = param.split('=')
      if (key === 'redirect') {
        url = value
        break
      }
    }
    return url
  }
  /**
   * 登录提交
   */
  const handleSubmit = async () => {
    try {
      const formData = await form.validateFields()
      const redirect = getRedirect()

      setLoading(true)
      await userLogin(formData.account, formData.password, imageData.key, formData.captcha)

      // 获取地址栏的redirect 进行跳转
      window.location.replace(redirect ? decodeURIComponent(redirect) : '/')
      setLoading(false)
    } catch (e: any) {
      fetchImageCaptcha()
      setLoading(false)
    }
  }

  return (
    <section className="login">
      <div className="login-slogan">
        <Gallery autoPlay images={[{ original: slogan1 }, { original: slogan2 }]} />
      </div>
      <div className="login-form">
        <div className="login-form__content">
          <div className="login-form__content-logo" style={{ textAlign: 'center' }}>
            <span className="logo" style={{ width: 308, height: 54 }}></span>
          </div>
          <h3>欢迎登录</h3>
          <Form
            name="basic"
            layout="vertical"
            form={form}
            initialValues={{ account: '', password: '', captcha: '' }}
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <Form.Item name="account" rules={[{ required: true, message: '请输入登录账号' }]}>
              <Input style={{ height: 42 }} placeholder="登录账号" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: '请输入登录密码' }]}>
              <Input.Password type="password" style={{ height: 42 }} placeholder="登录密码" />
            </Form.Item>
            <Form.Item name="captcha" rules={[{ required: true, message: '请输入验证码' }]}>
              <div className="code-wrap">
                <div className="code-input">
                  <Input style={{ height: 42 }} placeholder="验证码" />
                </div>
                <div className="code-image" onClick={fetchImageCaptcha}>
                  {imageData.image && <img src={imageData.image} />}
                </div>
              </div>
            </Form.Item>
            <Form.Item label={null}>
              <Button type="primary" loading={loading} className="login-form__submit" htmlType="submit">
                登 录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </section>
  )
}
